import { render, staticRenderFns } from "./AlertInvitationUpperLimit.vue?vue&type=template&id=1770147f&scoped=true"
import script from "./AlertInvitationUpperLimit.vue?vue&type=script&lang=js"
export * from "./AlertInvitationUpperLimit.vue?vue&type=script&lang=js"
import style0 from "./AlertInvitationUpperLimit.vue?vue&type=style&index=0&id=1770147f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770147f",
  null
  
)

export default component.exports